<template>
  <div v-if="isMobile">
    <s-bottom-sheet
      :value="isShownWhatsappInputDialog"
      :expanded="false"
      showToggler
      :clickToClose="true"
      cluster="k"
      @close="saveSettings('dismissed')"
    >
      <div class="bottom-sheet-content-wrapper">
        <div class="fs-16 text-ui-primary fw-600 header">Jangan Sampai Terlewat</div>
        <whatsapp-content @input="getUpdatedPhoneNumber" @validate="validatePhoneNumber" class="my-0 mx-auto" />
      </div>
      <template #footer>
        <div class="text-center">
          <s-button id="mweb-submit-input-whatsapp" :disabled="!isValidPhoneNumber" class="w-100 mw-100" :class="btnSubmitClass" :loading="isLoading" cluster="k" @click="saveSettings">Simpan</s-button>
        </div>
      </template>
    </s-bottom-sheet>
  </div>
</template>

<script>
import WhatsappContent from '@/components/dialog/whatsapp/Content.vue'
import inputWhatsappMixins from '@/mixins/inputWhatsapp.js'

export default {
  name: 'BottomSheetWhatsappInput',
  mixins: [inputWhatsappMixins],
  components: {
    WhatsappContent
  }
}
</script>

<style scoped>
.bottom-sheet-content-wrapper {
  padding: 16px 16px 0;
}

.header {
  padding: 10px 4px 10px 0;
  margin-bottom: 8px;
}

::v-deep .k-input {
  height: 72px;
}
</style>
